import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideLottieOptions } from 'ngx-lottie';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';
import player from 'lottie-web';
import { routes } from './app.routes';
import { AuthInterceptor } from './modules/services/auth.interceptor';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ModalModule } from 'ngx-bootstrap/modal';
import { roleInterceptor } from './modules/services/role-interceptor.guard';
import { SettingsService } from './modules/services/settings/settings.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    importProvidersFrom(ModalModule),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([roleInterceptor])
    ),
    provideLottieOptions({
      player: () => player,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(SharedModule),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const settingsService = inject(SettingsService);
      settingsService.resolveApplicationColorScheme();
    })
  ],
};
